import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const HomePage: React.FC = () => {
    const [roomCode, setRoomCode] = useState('');
    const [hostName, setHostName] = useState('');
    const [isStreamerMode, setIsStreamerMode] = useState(false);
    const navigate = useNavigate();

    const createRoom = () => {
        if (hostName.trim()) {
            // Geçici olarak rastgele oda kodu oluşturuyoruz
            const newRoomCode = Math.random().toString(36).substring(2, 8).toUpperCase();
            const streamerParam = isStreamerMode ? '&streamer=true' : '';
            navigate(`/room/${newRoomCode}?host=${encodeURIComponent(hostName)}${streamerParam}`);
        }
    };

    const joinRoom = () => {
        if (roomCode.trim()) {
            navigate(`/join?room=${roomCode.toUpperCase()}`);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center px-4 py-8">
            <div className="max-w-md w-full text-center">
                <h1 className="text-4xl sm:text-6xl font-bold text-white mb-2">WORDLE</h1>
                <p className="text-lg sm:text-xl text-gray-300 mb-8">Grup Oyunu</p>

                <div className="bg-gray-800 rounded-lg p-8 space-y-6">
                    <div>
                        <h2 className="text-2xl font-semibold text-white mb-4">Oyun Kuralları</h2>
                        <ul className="text-gray-300 text-left space-y-2">
                            <li>• Host 4-8 harf arası bir kelime belirler</li>
                            <li>• Diğer oyuncular 6 denemede kelimeyi bulur</li>
                            <li>• Yeşil: Doğru harf, doğru pozisyon</li>
                            <li>• Sarı: Doğru harf, yanlış pozisyon</li>
                            <li>• Gri: Harf kelimede yok</li>
                            <li>• Host kelimeyi görebilir, diğerleri tahmin eder</li>
                            <li>• 4,5,6,7,8 harfli kelimeler ile oynayabilirsiniz</li>
                        </ul>

                        <div className="bg-yellow-900 bg-opacity-30 border border-yellow-500 rounded-lg p-3 mt-4">
                            <p className="text-yellow-200 text-sm">
                                🚧 <strong>Oyun Geliştirme Modunda:</strong> Kelime veritabanı sürekli güncellenmektedir.
                                5 harfli kelimeler ile oynamanız tavsiye edilir.
                            </p>
                        </div>
                    </div>

                    <div className="space-y-4">
                        <div>
                            <label className="block text-white text-sm font-medium mb-2">
                                Host Adınız
                            </label>
                            <input
                                type="text"
                                value={hostName}
                                onChange={(e) => setHostName(e.target.value)}
                                placeholder="Adınızı girin"
                                className="w-full px-4 py-3 bg-gray-700 text-white rounded-lg border border-gray-600 focus:border-wordle-green focus:outline-none mb-4"
                                maxLength={20}
                            />
                        </div>

                        <div className="flex items-center space-x-3">
                            <input
                                type="checkbox"
                                id="streamerMode"
                                checked={isStreamerMode}
                                onChange={(e) => setIsStreamerMode(e.target.checked)}
                                className="w-4 h-4 text-wordle-green bg-gray-700 border-gray-600 rounded focus:ring-wordle-green focus:ring-2"
                            />
                            <label htmlFor="streamerMode" className="text-white text-sm">
                                📺 Yayıncı Modu (Bilgileri gizle)
                            </label>
                        </div>
                        <button
                            onClick={createRoom}
                            disabled={!hostName.trim()}
                            className="w-full bg-wordle-green hover:bg-green-600 disabled:bg-gray-600 disabled:cursor-not-allowed text-white font-semibold py-3 px-6 rounded-lg transition-colors"
                        >
                            Yeni Oda Oluştur
                        </button>

                        <div className="flex space-x-2">
                            <input
                                type="text"
                                value={roomCode}
                                onChange={(e) => setRoomCode(e.target.value.toUpperCase())}
                                placeholder="Oda kodu girin"
                                className="flex-1 px-4 py-3 bg-gray-700 text-white rounded-lg border border-gray-600 focus:border-wordle-green focus:outline-none"
                                maxLength={6}
                            />
                            <button
                                onClick={joinRoom}
                                disabled={!roomCode.trim()}
                                className="px-6 py-3 bg-wordle-yellow hover:bg-yellow-600 disabled:bg-gray-600 disabled:cursor-not-allowed text-white font-semibold rounded-lg transition-colors"
                            >
                                Katıl
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomePage;